const VALID_YEAR_RULE = /^\d{4}$/;

export const rule = (year = '') => {
  if (`${year}`.trim() === '') {
    return true;
  }

  return VALID_YEAR_RULE.test(year);
};

export const message = 'This field is not a valid year.';
